import { Random } from "~/utils";
import { playerLeaderRepository } from "./constant/playerLeaders";
import { NewPlayerProps, Player } from "./Player";

export const newPlayerFactory = ({
  id = Random.nextReadableId(),
  name = "Roger",
  playerLeader,
}: Partial<NewPlayerProps> = {}): Player => {
  playerLeader = playerLeader ?? playerLeaderRepository.entities.at(0);
  if (!playerLeader) throw new Error("error init player faction 0");
  return Player.new({
    id,
    name,
    playerLeader: playerLeader,
    dreadnoughtCount: 0,
  });
};
